/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios'
import {
  MAINHOST,
  UPLOADHOST,
  PROCESSHOST
} from "./config"
import {
  getDeviceType, is_wei
} from '@/common/getDeviceType/getDeviceType'
import {
  getURLParam
} from '../utils/common'
import {
  TOKEN_KEY,
  ACCOUNTORG_KEY
} from '../utils/common'
import Cookies from 'js-cookie'
// import {router} from '@/router/index'


//axios配置
// ithCredentials = true; //让axios携带cookie
axios.defaults.timeout = 20000; //超时配置
// axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
// axios.defaults.baseURL = MAINHOST;
axios.defaults.retry = 3; //请求次数
axios.defaults.retryDelay = 1000;


/** 
 * 跳转安卓登录页
 *  
 */
const toLogin = () => {

  //这里需要调用安卓IOS
  // var deviceType = getDeviceType();
  if (getDeviceType() == "android") {
    window.android.getInfo(106) //调用安卓
  } else {
    //调用IOS
    window.webkit.messageHandlers.closePage.postMessage("1");
  }
}
// 请求拦截器
axios.interceptors.request.use(
  config => {
    let phoneType = 'app';
    let token = "";
    if (is_wei()) {
      token = Cookies.get(TOKEN_KEY)
    } else {
      token = getURLParam("token");
      Cookies.set(TOKEN_KEY, token);
    }
    let orgId = getURLParam("orgId");
    Cookies.set(ACCOUNTORG_KEY, orgId);
    if (token) {
      config.headers = {
        token: token,
        client: phoneType,
        orgId: orgId
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)


/** 
 * 请求失败后的错误统一处理 
 * status 请求失败的状态码
 */
const errorHandle = (status, msg) => {
  // 状态码判断
  switch (status) {
    case "11001":
      toLogin()
      break
    case "11007":
      toLogin()
      break
    default:
      window.console.log(msg)
  }
}

// 响应拦截器
axios.interceptors.response.use(
  // 请求成功
  res => (res.status === 200 ? Promise.resolve(res) : Promise.reject(res)),
  // 请求失败
  error => {
    const {
      response
    } = error
    if (response) {
      // 请求已发出，但是不在2xx的范围
      errorHandle(response.status, response.data.message)
      return Promise.reject(response)
    } else {
      // 处理断网的情况
      return Promise.reject(error)
    }
  }
)

export const postRequest = (url, params, type) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: type == 'process' ? `${PROCESSHOST}${url}` : `${MAINHOST}${url}`,
      data: params
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
export const postRequestParams = (url, params) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: `${MAINHOST}${url}`,
      params: params
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
export const postDataParams = (url, params, data) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: `${MAINHOST}${url}`,
      params: params,
      data: data
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
export const fileUpload = (url, params) => {
  return axios({
    method: 'post',
    url: `${UPLOADHOST}${url}`,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: params
  })
}
export const getRequest = (url, params, type) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: type == 'process' ? `${PROCESSHOST}${url}` : `${MAINHOST}${url}`,
      params: params
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}

export const deleteRequest = (url, params) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'delete',
      url: `${MAINHOST}${url}`,
      params: params
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}